import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'

import categories from '@/assets/json/expense_categories.json'
import LButton from '@/components/core/Button.vue'
import DropdownMenu from '@/components/core/DropdownMenu.vue'
import DropdownMenuItem from '@/components/core/DropdownMenuItem.vue'
import { expenseModule, tripModule } from '@/store'
import { Expense } from '@/types/expense'
import { useSelectedTrip } from '@/composables/trip'


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySelect',
  props: {
    expense: null
  },
  emits: ["click:category"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click:category', category: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  expense?: Pick<Expense, '_id' | 'category'>
};





const trip = useSelectedTrip()

const currentExpense = computed(() => props.expense || expenseModule.expense)

const activeCategory = ref(currentExpense.value?.category || 'general')

const categoryImage = computed(
  () => `expense_category_${activeCategory.value}.png`,
)

watch(currentExpense, () => {
  activeCategory.value = currentExpense.value?.category || 'general'
})

async function updateExpense(category: string): Promise<void> {
  activeCategory.value = category
  emit('click:category', category)

  if (!currentExpense.value?._id) {
    return
  }

  await expenseModule.updateExpense({
    tripId: trip.value?.id,
    payload: { category },
    expenseId: currentExpense.value._id,
  })

  await tripModule.fetch(trip.value!.id)

  if (props.expense) {
    return
  }

  const updatedExpense = trip.value?.expenses.find(
    (expense) => expense._id === currentExpense.value?._id,
  )

  if (updatedExpense) {
    expenseModule.setCurrentExpense(updatedExpense)
  }
}

return { __sfc: true,props, emit, trip, currentExpense, activeCategory, categoryImage, updateExpense, categories, LButton, DropdownMenu, DropdownMenuItem }
}

})